import { Steps } from 'antd';
import { MainLayout } from 'components';
import { ReactNode, useEffect } from 'react';
import useCategoryManagementStore from 'store/categoryManagementStore';
import { CheckIcon } from 'assets/svg';
import pageTitleStore from 'store/pageTitleStore';

interface IProps {
  children: ReactNode;
  isLoading?: boolean;
  edit?: boolean;
}

export default function DeclareCartPage(props: IProps): JSX.Element {
  const { children, isLoading, edit } = props;
  const step = useCategoryManagementStore((state) => state.step);
  const infoSteps = edit
    ? [
        {
          title: 'Khai báo mẫu và SL',
          icon: <>{step >= 1 ? <CheckIcon /> : '1'}</>,
          className: 'step-first',
        },
        {
          title: 'Kiểm tra thông tin',
          icon: <>{step >= 2 ? <CheckIcon /> : '2'}</>,
          className: 'step-last',
        },
      ]
    : [
        {
          title: 'Khai báo giỏ hàng',
          icon: <>{step >= 1 ? <CheckIcon /> : '1'}</>,
          className: 'step-first',
        },
        {
          title: 'Khai báo mẫu và SL',
          icon: <>{step >= 2 ? <CheckIcon /> : '2'}</>,
          className: 'step-mid',
        },
        {
          title: 'Kiểm tra thông tin',
          icon: <>{step >= 3 ? <CheckIcon /> : '3'}</>,
          className: 'step-last',
        },
      ];
  const setTitle = pageTitleStore((state) => state.setTitle);
  const setBreadcrumb = pageTitleStore((state) => state.setBreadcrumb);
  useEffect(() => {
    setTitle('Tạo giỏ hàng');
    setBreadcrumb([
      {
        title: (
          <p>
            <a href="/cart-list">Giỏ hàng</a>{' '}
          </p>
        ),
      },
      { title: <a>Tạo giỏ hàng</a> },
    ]);
  }, []);

  return (
    <MainLayout isLoading={isLoading}>
      <Steps
        current={step}
        className="add-category-step mb-7"
        items={infoSteps}
      />
      <div className="p-1">{children}</div>
    </MainLayout>
  );
}
